import { render, staticRenderFns } from "./View2.vue?vue&type=template&id=4a21ee58&scoped=true&"
import script from "./View2.vue?vue&type=script&lang=js&"
export * from "./View2.vue?vue&type=script&lang=js&"
import style0 from "./View2.vue?vue&type=style&index=0&id=4a21ee58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21ee58",
  null
  
)

export default component.exports